export const OPACITY_UNSELECTED_SHELF = 0.2;
export const OPACITY_UNSELECTED_CORNER = 0.5;
export const USE_ORBIT_CONTROLS = true;
export const USE_ZOOM_ON_CURSOR_POSITION = true;
export const MATERIAL_CROSSPIECE_COLOR = 0xffffff;
export const MATERIAL_CROSSPIECE_SPECULAR = 0xfafafa;
export const MATERIAL_CROSSPIECE_SHININESS = 0.5;
export const MATERIAL_BATTEN_COLOR = 0xe0bf98;
export const MATERIAL_BATTEN_SPECULAR = 0x818075;
export const MATERIAL_BATTEN_SHININESS = 3;
export const MATERIAL_BATTEN_ALU_COLOR = 0xc4c4c4;
export const MATERIAL_BATTEN_ALU_SPECULAR = 0xffffff;
export const MATERIAL_BATTEN_ALU_SHININESS = 2.63902;
export const MATERIAL_BATTEN_ALU_BLACK_COLOR = 0x000000;
export const MATERIAL_BATTEN_ALU_BLACK_SPECULAR = 0xffffff;
export const MATERIAL_BATTEN_ALU_BLACK_SHININESS = 2.63902;
export const MATERIAL_BATTEN_ALU_WHITE_COLOR = 0xffffff;
export const MATERIAL_BATTEN_ALU_WHITE_SPECULAR = 0xffffff;
export const MATERIAL_BATTEN_ALU_WHITE_SHININESS = 2.63902;
export const MATERIAL_MIRROR2_COLOR = 0xd1d7d8;
export const MATERIAL_MIRROR2_SPECULAR = 0xffffff;
export const MATERIAL_MIRROR2_SHININESS = 6;
export const MATERIAL_MIRROR_COLOR = 0x595959;
export const MATERIAL_MIRROR_SPECULAR = 0xffffff;
export const MATERIAL_MIRROR_SHININESS = 6.99604;
export const MATERIAL_ALU_COLOR = 0x9ea5a5;
export const MATERIAL_ALU_SPECULAR = 0xffffff;
export const MATERIAL_ALU_SHININESS = 5.91371;
export const MATERIAL_GLASS_COLOR = 0x616d67; // 0x808f87;
export const MATERIAL_GLASS_SPECULAR = 0xffffff;
export const MATERIAL_GLASS_SHININESS = 8; //5.18959;
export const MATERIAL_GLASS_OPACITY = 0.2; // 0.15;
export const MATERIAL_MDFNATURAL_COLOR = 0xefede3;

export const MODEL_CABINET_WIDTH = 999;
export const MODEL_CABINET_DEPTH = 419;
export const MODEL_CABINET_HEIGHT = 450;
export const MODEL_CABINET_HEIGHT_WITH_UPPER_SHELF = 468;
export const MODEL_BATTEN_HEIGHT = 140;
export const MODEL_DRAWER_HEIGHT = 370;
export const MODEL_SHELF_HEIGHT = 370;
export const MODEL_PANE_HEIGHT = 380;

export const DATA_DIFF_DEPTH_DRAWER_CABINET = 39;

export const DEFAULT_CAMERA_POSITION = [-1482, 932, 5403];
export const POV_LEFT = [-2626, 3.5, 5403];

export const CONF_HUMAN_SIZE = 1750;
export const CONF_FOV_RELATIVE_TO_HUMAN_SIZE = 22;
export const CONF_HUMAN_SIZE_ACTIVE = false;

export const ANIMATIONS_DURATION_CAMERA = 300;
export const ANIMATIONS_ACTIVE_CAMERA = true;
// export const ANIMATIONS_ACTIVE_CAMERA = process.env.NODE_ENV !== 'production';
export const REACT_SPRING_ANIMATIONS_ACTIVE = true;
// export const REACT_SPRING_ANIMATIONS_ACTIVE =
//   process.env.NODE_ENV !== 'production';
/*
export const REACT_SPRING_ANIMATIONS_CONF = {
  duration: ANIMATIONS_DURATION_CAMERA,
};
*/
export const REACT_SPRING_ANIMATIONS_CONF = {};
export const REACT_SPRING_DOORS_ANIMATIONS_ACTIVE = true;
export const REACT_SPRING_DOORS_ANIMATIONS_CONF = { friction: 110 };

export const ZORDER_CORNER = 100;

export const ZORDER_UPPER_SHELF = 92;
export const ZORDER_UPPER_PLATE_GLASS = 91;
export const ZORDER_UPPER_PLATE = 90;

export const ZORDER_HANDLE = 85;

export const ZORDER_DOOR_HOLE_SHADOW = 82;
export const ZORDER_DOORS = 82;

export const ZORDER_INTERSHELF = 82;
export const ZORDER_INTERSHELF_SUPPORT = 81;
export const ZORDER_INTERSHELF_SUPPORT_TEXTURED = 83;
export const ZORDER_INTERSHELF_SUPPORT_GLASS = 83;

export const ZORDER_PANES_SIDES_BACK = 82;

export const ZORDER_INNER_PLATE_GLASS = 21;
export const ZORDER_INNER_PLATE = 20;

/**
 * REDUX Action Constants
 */

enum ActionTypes {
  OPEN_DOORS = 'app/Viewer/OPEN_DOORS',
  DISPLAY_MARKING = 'app/Viewer/DISPLAY_MARKING',
  FURNITURE_DISPLAYED = 'app/Viewer/FURNITURE_DISPLAYED',
  CABINET_DISPLAYED = 'app/Viewer/CABINET_DISPLAYED',
}

export default ActionTypes;
